import { sendGetRequest, sendPostRequest } from "@/helper/requests"
import reference from "@/urls/reference"
import { executeRequest } from '@/store/utils'

const state = {
  personal: {
    list: [],
    loading: null,
    count: 0,
  }
}

const getters = {
  getPersonalList: (state) => state.personal.list,
  getPersonalListCount: (state) => state.personal.count,
  isPersonalListLoading: (state) => state.personal.loading,
}

const actions = {
  loadPersonalList: ({ commit }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает список персонала
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.urlAppend - функция для модификации URL (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    commit('SET_LOADING')
    if (!url) {
      url = reference.CONTACTS.PERSONAL.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    sendGetRequest(
      url,
      (data, url) => {
        commit('SET_PERSONAL_LIST', data.results)
        commit('SET_PERSONAL_COUNT', data.count)
        commit('SET_NOT_LOADING')
        finalizer(data, url)
      },
      (error) => {
        commit('SET_NOT_LOADING')
        catcher(error)
      }
    )
  },
  makeReportProblem: ({ dispatch, commit, getters }, { id, data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Создает отчет о проблеме для сотрудника
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string|number} params.id - идентификатор сотрудника
     * @param {Object} params.data - данные отчета о проблеме
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = reference.CONTACTS.PERSONAL.ISSUE(id)
    executeRequest('Personal', sendPostRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  },
}

const mutations = {
  SET_PERSONAL_LIST: (state, list) => {
    /**
     * Устанавливает список персонала
     * @param {Object} state - состояние хранилища
     * @param {Array} list - массив объектов персонала
     */
    state.personal.list = list
  },
  SET_LOADING: (state) => {
    /**
     * Включает индикатор загрузки списка персонала
     * @param {Object} state - состояние хранилища
     */
    state.personal.loading = true
  },
  SET_NOT_LOADING: (state) => {
    /**
     * Выключает индикатор загрузки списка персонала
     * @param {Object} state - состояние хранилища
     */
    state.personal.loading = false
  },
  SET_PERSONAL_COUNT: (state, count) => {
    /**
     * Устанавливает общее количество записей персонала
     * @param {Object} state - состояние хранилища
     * @param {number} count - количество записей
     */
    state.personal.count = count
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
